import styled from "@emotion/styled";

import {
  getToggleDescriptionStyles,
  getToggleLabelStyles,
  getToggleThumbStyles,
  getToggleTrackStyles,
} from "./toggle-styles";
import type { StyledToggleProps, ToggleStyleProps } from "./types";

export const Container = styled.label<{
  $disabled: boolean;
  $labelPosition: "left" | "right";
}>`
  display: inline-flex;
  align-items: flex-start;
  gap: 12px;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  flex-direction: ${({ $labelPosition }) =>
    $labelPosition === "left" ? "row-reverse" : "row"};
  user-select: none;
  -webkit-tap-highlight-color: transparent;

  &:focus-within {
    outline: none;
  }
`;

export const Track = styled.div<StyledToggleProps>`
  ${({
    $checked,
    $disabled,
    $trackWidth,
    $trackHeight,
    $thumbSize,
    $translate,
    $styleProps,
  }) => {
    const tokens = {
      trackWidth: $trackWidth,
      trackHeight: $trackHeight,
      thumb: $thumbSize,
      translate: $translate,
    };
    return getToggleTrackStyles($checked, $disabled, tokens, $styleProps);
  }}
`;

export const Thumb = styled.div<StyledToggleProps>`
  ${({
    $checked,
    $disabled,
    $trackWidth,
    $trackHeight,
    $thumbSize,
    $translate,
    $styleProps,
  }) => {
    const tokens = {
      trackWidth: $trackWidth,
      trackHeight: $trackHeight,
      thumb: $thumbSize,
      translate: $translate,
    };
    return getToggleThumbStyles($checked, $disabled, tokens, $styleProps);
  }}
`;

export const HiddenInput = styled.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;
`;

export const LabelContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const LabelText = styled.span<{
  $disabled: boolean;
  $styleProps?: ToggleStyleProps | undefined;
}>`
  ${({ $disabled, $styleProps }) =>
    getToggleLabelStyles($disabled, $styleProps)}
`;

export const Description = styled.span<{
  $disabled: boolean;
  $styleProps?: ToggleStyleProps | undefined;
}>`
  ${({ $disabled, $styleProps }) =>
    getToggleDescriptionStyles($disabled, $styleProps)}
`;
